import PropTypes from 'prop-types';

import styles from './ManageTitle.scss';

export const ManageTitle = ({ title, subtitle }) => {
  return (
    <>
      <h1 id="manageTitle" className={styles.title} data-testid="ManageTitle">
        {title}
      </h1>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </>
  );
};

ManageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};
